import React from 'react'
import useApi from 'hooks/useApi'
import Chat from 'components/Chat'

const MessagesTab = ({ supplier }) => {
  const [supplierMsgs,,, loadSupplierMsgs] = useApi(`/message/supplierCoordinatorThread?supplierId=${supplier.uid}`)

  const onSend = (msg, subject = '') => {
    fetch(`/message/sendDirectSupplierMessage`,{
      method: 'POST',
      body: new URLSearchParams({
        msg,
        subject,
        supplierId: supplier.uid,
      })
    })
      .then(loadSupplierMsgs)
      .catch((error) => toastr.error(error))
  }

  return (
    <div>
        <Chat
          messages={supplierMsgs || []}
          onSend={onSend}
        />
    </div>
  )
}

export default MessagesTab
